/* Remove this file during FF: sign_core_2026_01_07_advanced_sig_frame cleanup */
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { InitialsField, SignatureField } from '@dropbox/sign-internal-client';
import { PREPARER, SENDER } from 'signer-app/signature-request/constants';
import Image from 'signer-app/signature-request/display-field/image';
import { Timestamped } from './signature-components/timestamped';

const messages = defineMessages({
  signature: {
    id: '294d051f877af968cfe9c760c2fc302735368bbb045b399ebc261fa64c8eae23',
    description: 'Alt text for an image of a signature.',
    defaultMessage: 'Signature',
  },
  signatureOfSenderOrPreparer: {
    id: '15444f30e17121bf3b0afcb8da2e5ecbbfbe9531ad767f48346610a8cfeee25a',
    description:
      'Alt text for an image of a signature from either the sender or preparer. Ex. "Signature of document preparer"',
    defaultMessage:
      'Signature of document {signer, select, preparer {preparer} sender {sender} other {signer}}',
  },
  signatureOfSigner: {
    id: 'b0ce8a715b6a9b43d57eb222b61a731e246b7ff0f4c0d2c3443dbe70ed0574df',
    description:
      'Alt text for an image of a signature from a signer with a specific index. Ex. "Signature of Signer 2"',
    defaultMessage: 'Signature of Signer {signer, number}',
  },
});

type Props = {
  fieldData: SignatureField | InitialsField;
  height: number;
  width: number;
  textScale: number;
  validationErrors: string[];
  getInstantValidationErrorHack: () => void;
  selectField: (fieldId: string) => void;
  updateFields: (fieldId: string, update: any) => void;
  isActive: boolean;
  documentPreview: boolean;
  runZoomIntoField: (fieldId: string) => void;
  isOverlay: boolean;
  showTimestamp?: boolean;
  isFormView?: boolean;
};

function Signature(
  {
    fieldData,
    height,
    width,
    textScale,
    validationErrors,
    getInstantValidationErrorHack,
    selectField,
    updateFields,
    isActive,
    documentPreview,
    runZoomIntoField,
    isOverlay,
    showTimestamp,
    isFormView,
    ...props
  }: Props,
  ref: React.ForwardedRef<unknown>,
) {
  const intl = useIntl();

  const altTextMessage = React.useMemo(() => {
    if ([PREPARER, SENDER].includes(fieldData.signer)) {
      return messages.signatureOfSenderOrPreparer;
    } else if (Number.isInteger(fieldData.signer)) {
      return messages.signatureOfSigner;
    } else {
      return messages.signature;
    }
  }, [fieldData]);

  if (fieldData.signature != null) {
    const img = (
      <Image
        isFormView={isFormView}
        alt={intl.formatMessage(altTextMessage, { signer: fieldData.signer })}
        id={fieldData.signature.guid}
        ref={ref}
        {...props}
      />
    );

    if (
      showTimestamp &&
      fieldData.type === 'signature' &&
      fieldData.signerName &&
      !fieldData.readOnly
    ) {
      return (
        <Timestamped fieldHeight={fieldData.height} name={fieldData.signerName}>
          {img}
        </Timestamped>
      );
    }

    return img;
  }

  return null;
}

/**
 * @deprecated Use SignatureField or InitialsField from './signature-components' instead
 */
export default React.forwardRef(Signature);
